import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { AppConstants } from '../constants/app-constants';

@Injectable({
  providedIn: 'root'
})
export class SkipSpinnerService {

  constructor() { }
  
  getHeaders(skipSpinner: boolean = false): HttpHeaders {
    let headers = new HttpHeaders();
    if (skipSpinner) {
      headers = headers.set(AppConstants.skipSpinner, 'true');
    }
    return headers;
  }
}